import { chain } from 'lodash';
function findFeats(myFeats, feats, isCustom) {
    return chain(myFeats).map((name, index) => {
        const foundFeat = feats.find(feat => name === feat.name);
        if (!foundFeat)
            console.error('Feat not found: ' + name);
        else {
            return {
                ...foundFeat,
                customIndex: isCustom ? index : -1,
                combat: true
            };
        }
    }).compact().value();
}
export default function generateFeats(rawCharacter, feats) {
    const fromClasses = chain(rawCharacter.classes)
        .map(({ abilityScoreImprovements }) => abilityScoreImprovements)
        .compact()
        .flatten()
        .filter(({ type }) => type === 'Feat')
        .map(feat => feat.name)
        .value();
    const myFeatsList = [
        ...fromClasses,
        ...(rawCharacter.background.feat && rawCharacter.background.feat.name ? [rawCharacter.background.feat.name] : [])
    ];
    return [
        ...findFeats(myFeatsList, feats, false),
        ...findFeats(rawCharacter.customFeats || [], feats, true)
    ];
}
